/* One shared Lottie runtime; each progress bar owns and cleans up its animation. */
(() => {
  if (customElements.get('sl-lottie-progress')) return;

  let library;
  function loadLibrary() {
    if (window.lottie) return Promise.resolve(window.lottie);
    if (!library) {
      library = new Promise((resolve, reject) => {
        const script = document.createElement('script');
        script.src = 'https://cdnjs.cloudflare.com/ajax/libs/lottie-web/5.12.2/lottie.min.js';
        script.onload = () => resolve(window.lottie);
        script.onerror = () => {
          script.remove();
          library = null;
          reject(new Error('Lottie could not load'));
        };
        document.head.appendChild(script);
      });
    }
    return library;
  }

  class LottieProgress extends HTMLElement {
    connectedCallback() {
      this.generation = (this.generation || 0) + 1;
      const generation = this.generation;
      const staticFrame = Boolean(window.Shopify?.designMode) ||
        window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      const start = async () => {
        this.observer?.disconnect();
        try {
          const lottie = await loadLibrary();
          if (!this.isConnected || generation !== this.generation || this.animation) return;
          this.animation = lottie.loadAnimation({
            container: this,
            renderer: 'svg',
            loop: false,
            autoplay: false,
            path: window.innerWidth <= 400 ? this.dataset.mobileSrc : this.dataset.desktopSrc,
          });
          this.animation.addEventListener('DOMLoaded', () => {
            if (!this.animation || generation !== this.generation) return;
            if (staticFrame) this.animation.goToAndStop(this.animation.totalFrames - 1, true);
            else this.animation.play();
          });
        } catch (error) {
          // Decorative media must not prevent the page or editor from working.
        }
      };
      if (staticFrame || !('IntersectionObserver' in window)) start();
      else {
        this.observer = new IntersectionObserver((entries) => {
          if (entries.some((entry) => entry.isIntersecting)) start();
        }, { threshold: 0.5 });
        this.observer.observe(this);
      }
    }

    disconnectedCallback() {
      this.generation += 1;
      this.observer?.disconnect();
      this.animation?.destroy();
      this.animation = null;
    }
  }

  customElements.define('sl-lottie-progress', LottieProgress);
})();
